import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import useTranslationValues from '@swf/core/hooks/useTranslationValues';

import { TXTWCL_Payee } from './PayeeRecord.messages.json';
import { brand, container } from './PayeeRecord.scss';

const PayeeRecord: React.FC = () => {
  const { rewardsBrand } = useTranslationValues();

  return (
    <div className={container}>
      <div>
        <Translation {...TXTWCL_Payee} />
      </div>
      <div className={brand}>{rewardsBrand}</div>
    </div>
  );
};

export default PayeeRecord;
